import { DomItem, ITimelineCtrl } from "../omnia";

export function toggleItemSelection(tl: ITimelineCtrl, item: DomItem) {

    if (!tl) return

    if (tl.isEditing() && tl.selection.multiple) {

        tl.selection.selectCropping(item.vm, !item.selected);
        updateEditModeSelection(tl, false)

    }

}


export function updateEditMode(tl: ITimelineCtrl) {

    if (!tl) return

    if (tl.isEditing()) {
        tl.popupContext = null
    }

    updateEditModeSelection(tl, true)

}

export function updateEditModeSelection(tl: ITimelineCtrl, render: boolean) {

    if (!tl) return

    const { items, selection } = tl

    if (!items) {
        return
    }

    let fieldIds: number[]
    let croppingIds: number[]

    const field = selection.field

    if (field) {

        fieldIds = [field.FieldId]

    }
    else {

        const cropping = selection.cropping;

        if (cropping) {
            croppingIds = cropping.map(c => c.CroppingId);
            fieldIds = omnia.getDistinctValues(cropping.map(c => c.FieldId), id => id);
        }

    }

    items.forEach(i => {

        if (i.vm.isField()) {
            i.selected = (!!fieldIds) && (fieldIds.some(id => id == i.vm.fieldId));
        }

        if (i.vm.isCropping()) {
            i.selected = (!!croppingIds) && (croppingIds.some(id => id == i.vm.croppingId));
        }

    })

    if (render) {
        tl.render()
    }

}
